module.exports = __webpack_public_path__ + "img/german.85f98c37.svg";